import axios from 'axios';
import AppConfig from "../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    getMiejscowosci() {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/miejscowosci' + AppConfig.V_LOG(),
        });
    },

    getGdzieJestMarcel() {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/trasy/lokalizacjaBusow' + AppConfig.V_LOG(),
        });
    },

    getPrzystankiMapa(idTr) {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/trasy/kurs/' + idTr + AppConfig.V_LOG(),
        });
    },

    getPrzystanki(idMw, idMd) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/przystanki' + AppConfig.V_LOG(),
            data: {
                "idMiDo": idMd,
                "idMiOd": idMw
            }
        });
    },

    getPrzystankiWyszukiwanie(idPrOd, idPrDo) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/miejscowosci/przystanki' + AppConfig.V_LOG(),
            data: {
                "idPrDo": idPrDo,
                "idPrOd": idPrOd
            }
        });
    },

    getPrzystanekInfo(id) {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/przystanki/' + id + AppConfig.V_LOG(),
        });
    },

    getZnizkiCennik(idKu, idKuPrze, idMiOd, idMiPrze, idMiDo, idTr, idTrPrze) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/znizki/wszystkie' + AppConfig.V_LOG(),
            data: {
                "idKu1": idKu,
                "idKu2": idKuPrze,
                "idMi1Do": idMiPrze,
                "idMi1Od": idMiOd,
                "idMi2Do": idMiDo,
                "idMi2Od": idMiPrze,
                "idTr1": idTr,
                "idTr2": idTrPrze
            }
        });
    },

    getRozklad(idPrWyj, idPrDoc, data, godzina) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/rozklad' + AppConfig.V_LOG(),
            data: {
                "data": data,
                "godz": godzina,
                "idPrDo": idPrDoc,
                "idPrOd": idPrWyj
            }
        });
    },

    getZnizki(idKu, idMiDo, idMiOd) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/znizki' + AppConfig.V_LOG(),
            data: {
                "idKu": idKu,
                "idMiDo": idMiDo,
                "idMiOd": idMiOd
            }
        });
    },

    getZnizkiLaczone(idKu, idKuPrze, idMiOd, idMiPrze, idMiDo) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/znizki/laczone' + AppConfig.V_LOG(),
            data: {
                "idKuDru": idKuPrze,
                "idKuPierw": idKu,
                "idMiDoDru": idMiDo,
                "idMiDoPierw": idMiPrze,
                "idMiOdDru": idMiPrze,
                "idMiOdPierw": idMiOd
            }
        });
    },

    getPrzystankiKursu(idKu) {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/search/wariantTrasy/przystanki/' + idKu + AppConfig.V_LOG(),
        });
    },

    getUzupelnione(idKl) {
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/klienci/uzupelnionyProfil/' + idKl + AppConfig.V_LOG(),
        });
    },

    getKonfigWartosc(pozycja, sekcja) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/konfig/getWartosc' + AppConfig.V_LOG(),
            data: {
                "pozycja": pozycja,
                "sekcja": sekcja
            }
        });
    },

    getSprawdzDostepne(idKu, idMiOd, idPrOd, idMiDo, idPro, rodz, ilosc, idKl) {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/bilety/pBiletyDostepneKursSprawdz?idKu=' + idKu + '&idMiOd=' + idMiOd + '&idPrOd=' + idPrOd + '&idMiDo=' + idMiDo + '&idPro=' + idPro + '&rodz=' + rodz + '&ilosc=' + ilosc + '&idKl=' + idKl + AppConfig.V_LOG_SECOND_PARAM(),
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/WyszukiwarkaService.js